import React, { createContext, useContext, useMemo, useState } from 'react';

interface SearchNavigationContextValue {
  pendingProductSheetId: string | null;
  setPendingProductSheetId: (id: string | null) => void;
}

interface HeaderSearchInputContextValue {
  searchInput: string;
  setSearchInput: React.Dispatch<React.SetStateAction<string>>;
}

const SearchNavigationContext = createContext<SearchNavigationContextValue | null>(null);
const HeaderSearchInputContext = createContext<HeaderSearchInputContextValue | null>(null);

export const SearchNavigationProvider = ({ children }: { readonly children: React.ReactNode }) => {
  const [pendingProductSheetId, setPendingProductSheetId] = useState<string | null>(null);
  const [searchInput, setSearchInput] = useState('');

  const value = useMemo(() => ({ pendingProductSheetId, setPendingProductSheetId }), [pendingProductSheetId]);
  const searchInputValue = useMemo(() => ({ searchInput, setSearchInput }), [searchInput]);

  return (
    <HeaderSearchInputContext.Provider value={searchInputValue}>
      <SearchNavigationContext.Provider value={value}>{children}</SearchNavigationContext.Provider>
    </HeaderSearchInputContext.Provider>
  );
};

export const useSearchNavigation = (): SearchNavigationContextValue => {
  const context = useContext(SearchNavigationContext);
  if (!context) throw new Error('useSearchNavigation must be used within a SearchNavigationProvider');
  return context;
};

export const useHeaderSearchInput = (): HeaderSearchInputContextValue => {
  const context = useContext(HeaderSearchInputContext);
  if (!context) throw new Error('useHeaderSearchInput must be used within a SearchNavigationProvider');
  return context;
};
